import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const BragBar = dynamic(() => import('./BragBar'));

Builder.registerComponent(BragBar, {
	name: 'BragBar',
	inputs: [
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: '#D3D3D3',
		},
		{
			name: 'items',
			friendlyName: 'Items',
			type: 'list',
			subFields: [
				{
					name: 'type',
					friendlyName: 'Content Type',
					type: 'string',
					enum: ['image', 'text'],
					defaultValue: 'image',
				},
				{
					name: 'logo',
					friendlyName: 'Image',
					type: 'file',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'gif', 'webp'],
					showIf: function (options) {
						return options.get('type') === 'image';
					},
				},
				{
					name: 'richText',
					friendlyName: 'Text',
					type: 'richText',
					showIf: function (options) {
						return options.get('type') === 'text';
					},
				},
				{
					name: 'link',
					friendlyName: 'Link',
					type: 'string',
					showIf: function (options) {
						return options.get('type') === 'image';
					},
				},
			],
			// eslint-disable-next-line @typescript-eslint/no-explicit-any, object-shorthand
			onChange: function (options: any) {
				if (options.get('items').length > 6) {
					options.set('items', options.get('items').slice(0, 6));
					alert('maximum items is 6, delete items to continue');
				}
			},
			defaultValue: [
				{
					type: 'image',
				},
			],
		},
		{
			name: 'alignment',
			friendlyName: 'Content Alignment',
			type: 'string',
			enum: [
				{ label: 'Space Around', value: 'space-around' },
				{ label: 'Space Between', value: 'space-between' },
				{ label: 'Space Evenly', value: 'space-evenly' },
				{ label: 'Center', value: 'center' },
				{ label: 'Left', value: 'left' },
				{ label: 'Right', value: 'right' },
			],
			defaultValue: 'space-around',
		},
		{
			name: 'separateMobileLayout',
			friendlyName: 'Separate Mobile Layout',
			type: 'boolean',
			defaultValue: false,
			helperText:
				'If true, the layout will be different on mobile devices. Click "Refresh your preview" to see the changes.',
		},
		{
			name: 'mobileLayout',
			friendlyName: 'Mobile Layout',
			type: 'object',
			required: false,
			helperText: 'Options for the mobile layout.',
			subFields: [
				{
					name: 'items',
					friendlyName: 'Items',
					type: 'list',
					subFields: [
						{
							name: 'type',
							friendlyName: 'Content Type',
							type: 'string',
							enum: ['image', 'text'],
							defaultValue: 'image',
						},
						{
							name: 'logo',
							friendlyName: 'Image',
							type: 'file',
							allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'gif', 'webp'],
							showIf: function (options) {
								return options.get('type') === 'image';
							},
						},
						{
							name: 'richText',
							friendlyName: 'Text',
							type: 'richText',
							showIf: function (options) {
								return options.get('type') === 'text';
							},
						},
						{
							name: 'link',
							friendlyName: 'Link',
							type: 'string',
							showIf: function (options) {
								return options.get('type') === 'image';
							},
						},
					],
					// eslint-disable-next-line @typescript-eslint/no-explicit-any, object-shorthand
					onChange: function (options: any) {
						if (options.get('items').length > 6) {
							options.set('items', options.get('items').slice(0, 6));
							alert('maximum items is 6, delete items to continue');
						}
					},
					defaultValue: [
						{
							type: 'image',
						},
					],
				},
				{
					name: 'alignment',
					friendlyName: 'Content Alignment',
					type: 'string',
					enum: [
						{ label: 'Space Around', value: 'space-around' },
						{ label: 'Space Between', value: 'space-between' },
						{ label: 'Space Evenly', value: 'space-evenly' },
						{ label: 'Center', value: 'center' },
						{ label: 'Left', value: 'left' },
						{ label: 'Right', value: 'right' },
					],
					defaultValue: 'space-around',
				},
			],
			showIf: function (options) {
				return options.get('separateMobileLayout') === true;
			},
		},
	],
	image: getIconUrl(Icon.LOGOBAR),
});
